import React from "react";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var HeaderContext = /*#__PURE__*/React.createContext({
  onSearchChange: function onSearchChange() {}
});
export var HeaderContextProvider = function HeaderContextProvider(_ref) {
  var children = _ref.children,
      onSearchChange = _ref.onSearchChange;
  return ___EmotionJSX(HeaderContext.Provider, {
    value: {
      onSearchChange: onSearchChange
    }
  }, children);
};